import { Component, Signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { LayoutService } from '@shared/services/layout.service';
import { LcoService } from '../../lco/services/lco.service';
import { Subject } from 'rxjs';
import { routerTransition, slideInAnimation } from '@shared/animations';
import { toSignal } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-main-layout',
  templateUrl: './main-layout.component.html',
  styleUrl: './main-layout.component.scss',
  animations: [
    slideInAnimation,
    routerTransition
  ],
})
export class MainLayoutComponent {
  config: Signal<any> = toSignal(this.layoutService.config);

  constructor(public layoutService: LayoutService,
              public lcoService: LcoService) {

  }

  prepareRoute(outlet: RouterOutlet) {
    return outlet?.activatedRouteData?.animation;
  }
}
